import React, { FC } from 'react';
import { useTenderPreview } from 'src/models/procurements/Preview/hooks';
import { CommentParentType } from 'src/models/comments/types';
import { Comments } from 'src/shared';
import { useActiveUsers } from 'src/models/users/hooks';
import { useParentComments } from 'src/models/comments/hooks';
import { Skeleton } from 'src/common';

export const TenderPreviewComments: FC = () => {
  const { data } = useTenderPreview();
  const id = data?.id;
  const [, { data: comments, loading }] = useParentComments({
    parentId: id ?? '',
    parentType: CommentParentType.Procurement
  });
  const users = useActiveUsers();

  return (
    <>
      {loading ? (
        <Skeleton loading active />
      ) : (
        id && (
          <Comments comments={comments ?? []} parentId={id} parentType={CommentParentType.Procurement} users={users} />
        )
      )}
    </>
  );
};

export default TenderPreviewComments;
